import type { PropsWithChildren } from 'react';

import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'

import { VendorsAPI } from '@webapp/api/VendorsAPI'
import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useFeatureFlag } from '@webapp/hooks'
import { type Vendor } from '@webapp/models'
import { VendorTooltip } from './VendorTooltip'

export interface IConnectedVendorTooltipProps {
  vendorId: Vendor['id']
}

export const ConnectedVendorTooltip = ({
  vendorId,
}: PropsWithChildren<IConnectedVendorTooltipProps>) => {
  const { enable_vendor_approvals: isVendorApprovalsEnabled } = useSelector(
    makeSelectFeatureSwitches()
  )

  const { data: vendor } = useQuery(
    ['vendor-detail', { id: vendorId }],
    () => {
      return VendorsAPI.getVendorDetail(vendorId).then((res) => res.data)
    },
    {
      cacheTime: 0,
    }
  )

  return (
    <VendorTooltip
      vendor={vendor}
      isVendorApprovalsEnabled={isVendorApprovalsEnabled}
    />
  )
}

ConnectedVendorTooltip.displayName = 'ConnectedVendorTooltip'
